import { post } from '~/shared/http-client/api'
import { type ApiResponse } from '~/shared/http-client/exceptions/type'

export type PaymentStartRequest = {
  paymentInfo: {
    goods_id: number
    divide: string
    quantity?: number
    option_1_quantity?: number
  }
}

export type PaymentResultRequest = {
  paymentInfo: {
    success: boolean
    order_code?: string
    payment_key?: string
    amount?: number
    payment_type?: string | undefined
    error_code?: string
  }
}

export interface PaymentResponse extends ApiResponse {
  data: {
    payment_info: {
      id: number
      event_id: number
      user_id: number
      type: string
      divide: string
      order_id: number
      order_code: string
      goods_id: number
      quantity: number
      amount: number
      discount_amount: number
      option_1_quantity: number
      option_1_amount: number
      mid: string
      currency: string
      method: string
      total_amount: number
      status: string
      requested_at: string
      approved_at: string
      approve_no: string
      payment_key: string
      payment_type: string
      payment_method: string
      error_code: string
      success: boolean
    }
  }
}

export interface PaymentResultResponse {
  errorCode: number
  errorMsg: string
}

export const postStartPayment = async ({
  paymentInfo: { goods_id, divide, quantity, option_1_quantity },
}: PaymentStartRequest) => {
  const response: PaymentResponse = await post(`/pay/start`, {
    paymentInfo: { goods_id, divide, quantity, option_1_quantity },
  })

  return response
}

export const postResultPayment = async ({
  paymentInfo: {
    success,
    order_code,
    payment_key,
    amount,
    payment_type,
    error_code,
  },
}: PaymentResultRequest) => {
  const response: PaymentResultResponse = await post(`/pay/result`, {
    paymentInfo: {
      success,
      order_code,
      payment_key,
      amount,
      payment_type,
      error_code,
    },
  })

  return response
}

export const postRefundPayment = async (id: number) => {
  const response: PaymentResultResponse = await post(`/pay/refund`, {
    paymentInfo: {
      id,
    },
  })

  return response
}
